import React, { useEffect, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  handleSetPin,
  setResetErrorMessage,
  setResetOtp,
} from "./cl_SetNewPinSlice";
import { getFromLocalStorage } from "../../services/helper/cl_Helper";
import { setResetSuccess } from "./cl_ResetSlice";

const SetNewPin = (props) => {
  const latestOTP = props?.otp.join("");
  const [pin, setPin] = useState({
    newPin: "",
    confirmPin: "",
  });
  const { resetErrorMessage, isLoading } = useSelector(
    (state) => state.setNewPin
  );
  const token = getFromLocalStorage("gt");
  const { resetOtp } = useSelector((state) => state.setNewPin);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pinErrorMsg, setPinErrorMsg] = useState("");
  const [confirmPinError, setConfirmPinError] = useState("");
  const [hidePassword, setHidePassword] = useState(true);
  const [hideConfirmPin, setHideConfirmPin] = useState(true);
  const numRegex = /^[0-9]+$/;
  const handlePinChange = (event) => {
    setPinErrorMsg("");
    setConfirmPinError("");
    dispatch(setResetErrorMessage(""));
    const name = event.target.name;
    const number = event.target.value;
    if (numRegex.test(number) || number === "") {
      setPin({ ...pin, [name]: number });
    }
  };
  const handleHidePassword = () => {
    setHidePassword(!hidePassword);
  };
  const handleConfirmPin = () => {
    setHideConfirmPin(!hideConfirmPin);
  };
  useEffect(() => {
    dispatch(setResetErrorMessage(""));
    setPinErrorMsg("");
    setConfirmPinError("");
  }, []);
  const handleSave = () => {
    if (isLoading) return;

    if (latestOTP === "" || latestOTP === null || latestOTP.length < 6) {
      dispatch(setResetErrorMessage("Please enter a valid 6-digit OTP"));
    } else if (pin.newPin.trim() === "") {
      setPinErrorMsg("Please enter a Valid 4 Digit PIN");
    } else if (pin.newPin.trim() === "" || pin.newPin.length < 4) {
      setPinErrorMsg("Please enter a Valid 4 Digit PIN");
    } else if (pin.confirmPin.trim() === "" || pin.confirmPin.length < 4) {
      setConfirmPinError("Please confirm your 4-digit PIN");
    } else if (pin.newPin !== pin.confirmPin) {
      setConfirmPinError("Please enter same PIN value in both the fields");
    } else {
      // const latesOTP = resetOtp?.join("");
      dispatch(setResetOtp(props?.otp));
      dispatch(setResetSuccess(false));
      dispatch(handleSetPin(latestOTP, pin?.confirmPin, navigate));
    }
    if (pin.confirmPin.trim() === "" || pin.confirmPin.length < 4) {
      setConfirmPinError("Please confirm your 4-digit PIN");
    }
    if (latestOTP === "" || latestOTP === null || latestOTP.length < 6) {
      dispatch(setResetErrorMessage("Please enter a valid 6-digit OTP"));
    }
    if (pin.newPin.trim() === "" || pin.newPin.length < 4) {
      setPinErrorMsg("Please enter a Valid 4 Digit PIN");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSave();
    }
  };
  return (
    <div id="SB-setNewPIN-container">
      {/* <div className="SB-loginRegister-title">Set New PIN</div> */}
      {/* <div className="SB-loginRegister-form"> */}
      <div className="SB-form-group">
        <div className="SB-form-label">4 Digit PIN</div>
        <div className="SB-form-control-group SB-form-control-password">
          <div className="SB-form-control">
            <input
              onChange={handlePinChange}
              type={hidePassword ? "password" : "tel"}
              placeholder="Enter Your PIN"
              required=""
              value={pin.newPin}
              maxLength={4}
              name="newPin"
            />
          </div>

          <div className="SB-form-addon SB-addon-right">
            <div
              className={`SB-iconSVG ${!hidePassword ? "d-none" : ""}`}
              title="password active"
              onClick={handleHidePassword}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#946969"
              >
                <use xlinkHref={`${icons}#${"icon-password-active"}`} />
              </svg>
            </div>
            <div
              className={`SB-iconSVG ${!hidePassword ? "" : "d-none"}`}
              title="Password hide"
              onClick={handleHidePassword}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#946969"
              >
                <use xlinkHref={`${icons}#${"icon-password"}`} />
              </svg>
            </div>
          </div>
        </div>
        <div className="SB-form-errorMsg">
          <span>{pinErrorMsg}</span>
        </div>
      </div>
      <div className="SB-form-group">
        <div className="SB-form-label">Confirm 4 Digit PIN</div>
        <div className="SB-form-control-group SB-form-control-password">
          <div className="SB-form-control">
            <input
              onChange={handlePinChange}
              type={hideConfirmPin ? "password" : "tel"}
              placeholder="Enter Your PIN"
              required=""
              value={pin.confirmPin}
              maxLength={4}
              name="confirmPin"
              onKeyPress={handleKeyPress}
            />
          </div>
          <div className="SB-form-addon SB-addon-right">
            <div
              className={`SB-iconSVG ${!hideConfirmPin ? "d-none" : ""}`}
              title="password active"
              onClick={handleConfirmPin}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#946969"
              >
                <use xlinkHref={`${icons}#${"icon-password-active"}`} />
              </svg>
            </div>
            <div
              className={`SB-iconSVG${!hideConfirmPin ? "" : "d-none"}`}
              title="Password hide"
              onClick={handleConfirmPin}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="#946969"
              >
                <use xlinkHref={`${icons}#${"icon-password"}`} />
              </svg>
            </div>
          </div>
        </div>
        <div className="SB-form-errorMsg">
          <span>{confirmPinError}</span>
        </div>
      </div>

      <div className="text-center">
        <button
          onClick={handleSave}
          className="btn SB-login SB-btnSecondary active SB-btnLarge"
          id="btnlogin"
        >
          {!isLoading ? (
            <div className="SB-btnTxt">Submit</div>
          ) : (
            <div className="SB-loader-container">
              <div className="SB-loader"></div>
            </div>
          )}
        </button>
      </div>
      {/* </div> */}
    </div>
  );
};
export default SetNewPin;
